import React, { useMemo, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import { isBenchmark } from '@aytm/app/insights/dashboard/helpers/checks'

// import { useExternalData } from '@aytm/app/insights/dashboard/components/hooks'

import { Menu as PrimeMenu } from 'primereact/menu'

import Overlay from '../../../Overlay'

import './Menu.css'

const CLASS = 'insights-portal-subject-menu'

const Menu = props => {
  const timer = useRef(0)

  const subject = useMemo(() => props.subject || {}, [props.subject])
  const editor = useMemo(() => props.editor || {}, [props.editor])
  const show = useMemo(
    () => props.index === editor.menuIndex && 'add' === editor.type,
    [editor.menuIndex, editor.type, props.index]
  )

  const onEditorChange = props.onEditorChange || null
  const showImage = props.showImage || false
  const index = props.index ?? -1
  const item = props.item || null

  const menuItems = useMemo(() => {
    const isExternalData = isBenchmark({ subject })
    const onEdit = event => {
      if (event && event.item) {
        timer.current = setTimeout(() => {
          onEditorChange?.({ type: event.item.id, itemIndex: index, item })
        }, 100)
      }
    }
    const items = [
      isExternalData
        ? { id: 'edit', label: 'Edit', command: onEdit }
        : { id: 'rename', label: 'Rename', command: onEdit }
    ]
    if ('concept' === subject.type) {
      items.push({ id: 'replace', label: 'Replace', command: onEdit })
      if (showImage && !isExternalData) {
        items.push({ id: 'change', label: 'Change image', command: onEdit })
      }
    }
    if ('concept' === subject.type || isExternalData) {
      items.push({ id: 'delete', label: 'Delete', command: onEdit })
    }
    return items
  }, [index, item, onEditorChange, showImage, subject])

  const onOuterClick = () => {
    onEditorChange?.({})
  }

  const onKeyDown = event => {
    if (onEditorChange && 'Escape' === event.key) {
      onEditorChange({})
    }
  }

  useEffect(() => () => clearTimeout(timer.current), [])

  return (
    <Overlay className={CLASS} show={show} onOuterClick={onOuterClick} onKeyDown={onKeyDown}>
      <PrimeMenu className={`insights-portal`} model={menuItems} />
    </Overlay>
  )
}

Menu.propTypes = {
  className: PropTypes.string,
  targetRef: PropTypes.object,
  index: PropTypes.number,
  item: PropTypes.object,
  editor: PropTypes.object,
  subject: PropTypes.object,
  showImage: PropTypes.any,
  onEditorChange: PropTypes.func
}

export default Menu
